import { render } from "./addRIIFile.vue?vue&type=template&id=5ccad0fa&scoped=true"
import script from "./addRIIFile.vue?vue&type=script&lang=js"
export * from "./addRIIFile.vue?vue&type=script&lang=js"

import "./addRIIFile.vue?vue&type=style&index=0&id=5ccad0fa&scoped=true&lang=css"
import "./addRIIFile.vue?vue&type=style&index=1&id=5ccad0fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccad0fa"]])

export default __exports__